//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthClient } from '../app/services/authService';
import { getAccessToken } from 'app/utils/authUtilities';
import { loginRequest, msalInstance } from "authConfig";
import { getDecodedData } from 'app/utils/authUtilities';
export class UserApiClientBase {
    constructor() { };

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        if (options.headers) {
            let token = getAccessToken();
            if(token === null) {
                token = await new AuthClient().getToken();
            } else if (this.tokenIsExpired()) {
                this.clearTokenAndRedirect();
            }
            var headers = options.headers as { [index: string]: string };
            headers['Authorization'] = `Bearer ${token}`;
        }
        return Promise.resolve(options);
    }

    protected async transformResult(
        url: string,
        response: Response,
        processResponse: (_response: Response) => Promise<any>
    ): Promise<any> {
        if (response.status === 401 || response.status === 403) {
            if(this.tokenIsExpired()) {
                this.clearTokenAndRedirect();
            }
        }

        try {
            return await processResponse(response);
        } catch (error: any) {
            if(response.ok) {
                return;
            }

            throw new ApiError(
                response.status,
                response.statusText,
                error?.result ?? error
            );
        }
    }

    private tokenIsExpired(): boolean {
        const accessToken = localStorage.getItem('accessToken');
        const accessTokenExpiration = getDecodedData(accessToken)?.exp;
        const currentTime = Math.floor(Date.now() / 1000);
        const tokenExpired = !accessToken || accessTokenExpiration < currentTime;
        return tokenExpired
    }
    
    private clearTokenAndRedirect(): void {
        localStorage.clear();
        msalInstance.acquireTokenRedirect(loginRequest);
        throw new Error('Access token expired. Redirecting to login for a new token.');
    }
}

export class UserApiClient extends UserApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    email_CreateEmail(email: EmailDto): Promise<void> {
        let url_ = this.baseUrl + "/user/Email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEmail_CreateEmail(_response));
        });
    }

    protected processEmail_CreateEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    email_GetEmailById(id: string): Promise<GetEmailDetailDto> {
        let url_ = this.baseUrl + "/user/Email/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEmail_GetEmailById(_response));
        });
    }

    protected processEmail_GetEmailById(response: Response): Promise<GetEmailDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmailDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetEmailDetailDto>(null as any);
    }

    email_GetEmails(pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfGetEmailSummaryDto> {
        let url_ = this.baseUrl + "/user/Email/List?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEmail_GetEmails(_response));
        });
    }

    protected processEmail_GetEmails(response: Response): Promise<PaginatedListOfGetEmailSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGetEmailSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGetEmailSummaryDto>(null as any);
    }

    emailTemplate_CreateEmailTemplate(emailTemplate: CreateEmailTemplateDto): Promise<GetEmailTemplateDetailDto> {
        let url_ = this.baseUrl + "/user/EmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailTemplate);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEmailTemplate_CreateEmailTemplate(_response));
        });
    }

    protected processEmailTemplate_CreateEmailTemplate(response: Response): Promise<GetEmailTemplateDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmailTemplateDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetEmailTemplateDetailDto>(null as any);
    }

    emailTemplate_GetEmailTemplateById(id: string): Promise<GetEmailTemplateDetailDto> {
        let url_ = this.baseUrl + "/user/EmailTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEmailTemplate_GetEmailTemplateById(_response));
        });
    }

    protected processEmailTemplate_GetEmailTemplateById(response: Response): Promise<GetEmailTemplateDetailDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmailTemplateDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetEmailTemplateDetailDto>(null as any);
    }

    emailTemplate_DeleteEmailTemplate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/user/EmailTemplate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEmailTemplate_DeleteEmailTemplate(_response));
        });
    }

    protected processEmailTemplate_DeleteEmailTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    emailTemplate_GetEmailTemplates(): Promise<GetEmailTemplateSummaryDto[]> {
        let url_ = this.baseUrl + "/user/EmailTemplate/List";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEmailTemplate_GetEmailTemplates(_response));
        });
    }

    protected processEmailTemplate_GetEmailTemplates(response: Response): Promise<GetEmailTemplateSummaryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetEmailTemplateSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetEmailTemplateSummaryDto[]>(null as any);
    }

    home_Index(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHome_Index(_response));
        });
    }

    protected processHome_Index(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets a users saved folders and lists
     * @return A UserList object
     */
    list_GetUserLists(): Promise<UserListDto> {
        let url_ = this.baseUrl + "/user/lists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList_GetUserLists(_response));
        });
    }

    protected processList_GetUserLists(response: Response): Promise<UserListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserListDto>(null as any);
    }

    /**
     * Creates a new list 
    If a user has yet to save a list, a new UserList is created with a new folder and the desired list to save 
    If a user has existing saved lists, the new list will be saved to the desired folder
     * @param userListDto The DTO used to save a new list
     * @return The ID of the newly saved list
     */
    list_UpdateUserLists(userListDto: UserListDto): Promise<string> {
        let url_ = this.baseUrl + "/user/lists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userListDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList_UpdateUserLists(_response));
        });
    }

    protected processList_UpdateUserLists(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Updates the properties of a list (Icon, Name, Folder)
     * @return A boolean indicating that a user list was successfully edited
     */
    list_UpdateUserListProperties(dto: UserListDto): Promise<boolean> {
        let url_ = this.baseUrl + "/user/lists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList_UpdateUserListProperties(_response));
        });
    }

    protected processList_UpdateUserListProperties(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Updates the properties of a Folder
     * @return A boolean indicating that a user list was successfully edited
     */
    list_UpdateFolderProperties(dto: UpdateFolderPropertyDto): Promise<Unit> {
        let url_ = this.baseUrl + "/user/lists/UpdateFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList_UpdateFolderProperties(_response));
        });
    }

    protected processList_UpdateFolderProperties(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }

    /**
     * Favorites a list
     * @return A boolean indicating that a user list was successfully edited
     */
    list_StarUserQuery(queryId: string): Promise<Unit> {
        let url_ = this.baseUrl + "/user/lists/Favorite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryId);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList_StarUserQuery(_response));
        });
    }

    protected processList_StarUserQuery(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }

    /**
     * Deletes a list
     * @param id The Guid
     * @return If the Deletion was success or failure
     */
    list_DeleteUserList(id: string): Promise<boolean> {
        let url_ = this.baseUrl + "/user/lists/Query/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList_DeleteUserList(_response));
        });
    }

    protected processList_DeleteUserList(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Deletes a folder
     * @param id The Guid
     * @return If the Deletion was success or failure
     */
    list_DeleteUserFolder(id: string): Promise<Unit> {
        let url_ = this.baseUrl + "/user/lists/Folder/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList_DeleteUserFolder(_response));
        });
    }

    protected processList_DeleteUserFolder(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }

    /**
     * Updates the query parameters of a list
     * @return A boolean indicating that a user list was successfully edited
     */
    list_UpdateListQuery(dto: ListQueryDto): Promise<Unit> {
        let url_ = this.baseUrl + "/user/lists/UpdateQuery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList_UpdateListQuery(_response));
        });
    }

    protected processList_UpdateListQuery(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }

    /**
     * Reorders the sequence of lists in a folder
     * @param dto The Folder in which the lists are being reordered
     * @return A boolean indicating that a user lists were successfully reordered
     */
    list_ReorderLists(dto: ListFolderDto): Promise<Unit> {
        let url_ = this.baseUrl + "/user/lists/Reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList_ReorderLists(_response));
        });
    }

    protected processList_ReorderLists(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }

    /**
     * Reorders the sequence of folders
     * @param dtos The reordered list of folders
     * @return A boolean indicating that a user's folders were successfully reordered
     */
    list_ReorderFolders(dtos: ListFolderDto[]): Promise<Unit> {
        let url_ = this.baseUrl + "/user/lists/Folder/Reorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtos);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList_ReorderFolders(_response));
        });
    }

    protected processList_ReorderFolders(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Unit.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }

    notification_GetUserNotifications(pageNumber: number | undefined, pageSize: number | undefined): Promise<PaginatedListOfNotificationDto> {
        let url_ = this.baseUrl + "/user/Notification?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNotification_GetUserNotifications(_response));
        });
    }

    protected processNotification_GetUserNotifications(response: Response): Promise<PaginatedListOfNotificationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfNotificationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfNotificationDto>(null as any);
    }

    notification_MarkAsRead(): Promise<boolean> {
        let url_ = this.baseUrl + "/user/Notification/MarkAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNotification_MarkAsRead(_response));
        });
    }

    protected processNotification_MarkAsRead(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    notification_GetUnreadNotificationCount(): Promise<number> {
        let url_ = this.baseUrl + "/user/Notification/UnreadCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNotification_GetUnreadNotificationCount(_response));
        });
    }

    protected processNotification_GetUnreadNotificationCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    notification_CreateReport(feedback: CreateNotificationUnsubscribeFeedbackDto): Promise<void> {
        let url_ = this.baseUrl + "/user/Notification/UnsubscribeFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedback);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processNotification_CreateReport(_response));
        });
    }

    protected processNotification_CreateReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    preference_GetUserPreferences(): Promise<UserPreferencesDto> {
        let url_ = this.baseUrl + "/user/Preference";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreference_GetUserPreferences(_response));
        });
    }

    protected processPreference_GetUserPreferences(response: Response): Promise<UserPreferencesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPreferencesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPreferencesDto>(null as any);
    }

    preference_UpdateUserPreferences(userPreference: UserPreferencesDto): Promise<void> {
        let url_ = this.baseUrl + "/user/Preference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userPreference);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreference_UpdateUserPreferences(_response));
        });
    }

    protected processPreference_UpdateUserPreferences(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    preference_SubscribeNewsletter(): Promise<boolean> {
        let url_ = this.baseUrl + "/user/Preference/SubscribeNewsletter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreference_SubscribeNewsletter(_response));
        });
    }

    protected processPreference_SubscribeNewsletter(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    preference_SubscribeKnowledgeCenter(): Promise<boolean> {
        let url_ = this.baseUrl + "/user/Preference/SubscribeKnowledgeCenter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreference_SubscribeKnowledgeCenter(_response));
        });
    }

    protected processPreference_SubscribeKnowledgeCenter(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    preference_UnsubscribeNewsletter(): Promise<boolean> {
        let url_ = this.baseUrl + "/user/Preference/UnsubscribeNewsletter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreference_UnsubscribeNewsletter(_response));
        });
    }

    protected processPreference_UnsubscribeNewsletter(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    preference_UnsubscribeKnowledgeCenter(): Promise<boolean> {
        let url_ = this.baseUrl + "/user/Preference/UnsubscribeKnowledgeCenter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreference_UnsubscribeKnowledgeCenter(_response));
        });
    }

    protected processPreference_UnsubscribeKnowledgeCenter(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    preference_GetCurrentUserInfo(): Promise<UserDto> {
        let url_ = this.baseUrl + "/user/Preference/CurrentUserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreference_GetCurrentUserInfo(_response));
        });
    }

    protected processPreference_GetCurrentUserInfo(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    preference_GetNewsletterSubscribers(): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/user/Preference/NewsletterSubscribers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreference_GetNewsletterSubscribers(_response));
        });
    }

    protected processPreference_GetNewsletterSubscribers(response: Response): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    preference_GetKnowledgeCenterSubscribers(): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/user/Preference/KnowledgeCenterSubscribers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPreference_GetKnowledgeCenterSubscribers(_response));
        });
    }

    protected processPreference_GetKnowledgeCenterSubscribers(response: Response): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    report_CreateReport(report: CreateReportDto): Promise<GetReportDto> {
        let url_ = this.baseUrl + "/user/Report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(report);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReport_CreateReport(_response));
        });
    }

    protected processReport_CreateReport(response: Response): Promise<GetReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetReportDto>(null as any);
    }

    report_UpdateReport(report: UpdateReportDto): Promise<GetReportDto> {
        let url_ = this.baseUrl + "/user/Report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(report);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReport_UpdateReport(_response));
        });
    }

    protected processReport_UpdateReport(response: Response): Promise<GetReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetReportDto>(null as any);
    }

    report_BookmarkReport(id: string): Promise<GetReportDto> {
        let url_ = this.baseUrl + "/user/Report/Bookmark/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReport_BookmarkReport(_response));
        });
    }

    protected processReport_BookmarkReport(response: Response): Promise<GetReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetReportDto>(null as any);
    }

    report_ShareReport(shareReport: UpdateReportSharedWithDto): Promise<GetReportDto> {
        let url_ = this.baseUrl + "/user/Report/Share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shareReport);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReport_ShareReport(_response));
        });
    }

    protected processReport_ShareReport(response: Response): Promise<GetReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetReportDto>(null as any);
    }

    report_GetReportById(id: string): Promise<GetReportDto> {
        let url_ = this.baseUrl + "/user/Report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReport_GetReportById(_response));
        });
    }

    protected processReport_GetReportById(response: Response): Promise<GetReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetReportDto>(null as any);
    }

    report_DeleteReport(id: string): Promise<void> {
        let url_ = this.baseUrl + "/user/Report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReport_DeleteReport(_response));
        });
    }

    protected processReport_DeleteReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    report_GetReports(filterBookmarkedReports: boolean | undefined, sharedWithUserId: string | null | undefined, sortProperty: string | null | undefined, sortDirection: ListSortDirection | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchText: string | null | undefined, type: ReportType | null | undefined): Promise<PaginatedListOfGetReportDto> {
        let url_ = this.baseUrl + "/user/Report/List?";
        if (filterBookmarkedReports === null)
            throw new Error("The parameter 'filterBookmarkedReports' cannot be null.");
        else if (filterBookmarkedReports !== undefined)
            url_ += "FilterBookmarkedReports=" + encodeURIComponent("" + filterBookmarkedReports) + "&";
        if (sharedWithUserId !== undefined && sharedWithUserId !== null)
            url_ += "SharedWithUserId=" + encodeURIComponent("" + sharedWithUserId) + "&";
        if (sortProperty !== undefined && sortProperty !== null)
            url_ += "SortProperty=" + encodeURIComponent("" + sortProperty) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReport_GetReports(_response));
        });
    }

    protected processReport_GetReports(response: Response): Promise<PaginatedListOfGetReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfGetReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfGetReportDto>(null as any);
    }

    report_HasBookmarkedReports(): Promise<boolean> {
        let url_ = this.baseUrl + "/user/Report/HasBookmarkedReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReport_HasBookmarkedReports(_response));
        });
    }

    protected processReport_HasBookmarkedReports(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Gets a list of all submitters
     * @return A list of submitters
     */
    submitter_GetAllSubmitters(): Promise<SubmitterDto[]> {
        let url_ = this.baseUrl + "/user/submitters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmitter_GetAllSubmitters(_response));
        });
    }

    protected processSubmitter_GetAllSubmitters(response: Response): Promise<SubmitterDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubmitterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitterDto[]>(null as any);
    }

    /**
     * Creates a new submitter and saves it to the database
     * @param dto The submitter dto
     * @return A boolean response indicating that the submitter was successfully saved to the DB
     */
    submitter_CreateSubmitter(dto: SubmitterDto): Promise<void> {
        let url_ = this.baseUrl + "/user/submitters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmitter_CreateSubmitter(_response));
        });
    }

    protected processSubmitter_CreateSubmitter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets a submitter by the id
     * @param id The Guid
     * @return A list of submitters
     */
    submitter_GetSubmitterById(id: string): Promise<SubmitterDto> {
        let url_ = this.baseUrl + "/user/submitters/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmitter_GetSubmitterById(_response));
        });
    }

    protected processSubmitter_GetSubmitterById(response: Response): Promise<SubmitterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitterDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitterDto>(null as any);
    }

    /**
     * Get Ids of Users with a certain RoleValue
     * @param role The Guid
     * @return Returns the list of User IDs with passed in Role Value
     */
    user_GetUsersByRoleName(role: string): Promise<GraphUserDto[]> {
        let url_ = this.baseUrl + "/User/UsersByRole/{role}";
        if (role === undefined || role === null)
            throw new Error("The parameter 'role' must be defined.");
        url_ = url_.replace("{role}", encodeURIComponent("" + role));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUser_GetUsersByRoleName(_response));
        });
    }

    protected processUser_GetUsersByRoleName(response: Response): Promise<GraphUserDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GraphUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GraphUserDto[]>(null as any);
    }

    user_SearchAdminUsers(searchText: string | null | undefined, maxResultCount: number | null | undefined, userDomain: RequestDomain | null | undefined): Promise<GraphUserDto[]> {
        let url_ = this.baseUrl + "/User/SearchAdminUsers?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (maxResultCount !== undefined && maxResultCount !== null)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (userDomain !== undefined && userDomain !== null)
            url_ += "UserDomain=" + encodeURIComponent("" + userDomain) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUser_SearchAdminUsers(_response));
        });
    }

    protected processUser_SearchAdminUsers(response: Response): Promise<GraphUserDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GraphUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GraphUserDto[]>(null as any);
    }

    user_SearchUsers(searchText: string | null | undefined): Promise<GraphUser[]> {
        let url_ = this.baseUrl + "/User/SearchUsers?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUser_SearchUsers(_response));
        });
    }

    protected processUser_SearchUsers(response: Response): Promise<GraphUser[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GraphUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GraphUser[]>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class EmailDto implements IEmailDto {
    subject?: string | undefined;
    content?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    bcc?: string[] | undefined;

    constructor(data?: IEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.content = _data["content"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            if (Array.isArray(_data["bcc"])) {
                this.bcc = [] as any;
                for (let item of _data["bcc"])
                    this.bcc!.push(item);
            }
        }
    }

    static fromJS(data: any): EmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["content"] = this.content;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item);
        }
        return data;
    }
}

export interface IEmailDto {
    subject?: string | undefined;
    content?: string | undefined;
    to?: string[] | undefined;
    cc?: string[] | undefined;
    bcc?: string[] | undefined;
}

export class GetEmailSummaryDto implements IGetEmailSummaryDto {
    id?: string;
    createdOn?: Date;
    subject?: string | undefined;
    to?: string[] | undefined;

    constructor(data?: IGetEmailSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            if (Array.isArray(_data["to"])) {
                this.to = [] as any;
                for (let item of _data["to"])
                    this.to!.push(item);
            }
        }
    }

    static fromJS(data: any): GetEmailSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        return data;
    }
}

export interface IGetEmailSummaryDto {
    id?: string;
    createdOn?: Date;
    subject?: string | undefined;
    to?: string[] | undefined;
}

export class GetEmailDetailDto extends GetEmailSummaryDto implements IGetEmailDetailDto {
    content?: string | undefined;
    cc?: string[] | undefined;
    bcc?: string[] | undefined;

    constructor(data?: IGetEmailDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"];
            if (Array.isArray(_data["cc"])) {
                this.cc = [] as any;
                for (let item of _data["cc"])
                    this.cc!.push(item);
            }
            if (Array.isArray(_data["bcc"])) {
                this.bcc = [] as any;
                for (let item of _data["bcc"])
                    this.bcc!.push(item);
            }
        }
    }

    static override fromJS(data: any): GetEmailDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        if (Array.isArray(this.cc)) {
            data["cc"] = [];
            for (let item of this.cc)
                data["cc"].push(item);
        }
        if (Array.isArray(this.bcc)) {
            data["bcc"] = [];
            for (let item of this.bcc)
                data["bcc"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGetEmailDetailDto extends IGetEmailSummaryDto {
    content?: string | undefined;
    cc?: string[] | undefined;
    bcc?: string[] | undefined;
}

export class PaginatedListOfGetEmailSummaryDto implements IPaginatedListOfGetEmailSummaryDto {
    items?: GetEmailSummaryDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfGetEmailSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetEmailSummaryDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfGetEmailSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfGetEmailSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfGetEmailSummaryDto {
    items?: GetEmailSummaryDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class GetEmailTemplateDetailDto implements IGetEmailTemplateDetailDto {
    id?: string;
    displayName?: string | undefined;
    content?: string | undefined;

    constructor(data?: IGetEmailTemplateDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): GetEmailTemplateDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailTemplateDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["content"] = this.content;
        return data;
    }
}

export interface IGetEmailTemplateDetailDto {
    id?: string;
    displayName?: string | undefined;
    content?: string | undefined;
}

export class CreateEmailTemplateDto implements ICreateEmailTemplateDto {
    displayName?: string | undefined;
    content?: string | undefined;

    constructor(data?: ICreateEmailTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CreateEmailTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["content"] = this.content;
        return data;
    }
}

export interface ICreateEmailTemplateDto {
    displayName?: string | undefined;
    content?: string | undefined;
}

export class GetEmailTemplateSummaryDto implements IGetEmailTemplateSummaryDto {
    id?: string;
    displayName?: string | undefined;
    createdBy?: BaseUserDto | undefined;

    constructor(data?: IGetEmailTemplateSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.createdBy = _data["createdBy"] ? BaseUserDto.fromJS(_data["createdBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEmailTemplateSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailTemplateSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEmailTemplateSummaryDto {
    id?: string;
    displayName?: string | undefined;
    createdBy?: BaseUserDto | undefined;
}

export class BaseUserDto implements IBaseUserDto {
    id?: string;
    displayName?: string | undefined;

    constructor(data?: IBaseUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): BaseUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IBaseUserDto {
    id?: string;
    displayName?: string | undefined;
}

export class UserListDto implements IUserListDto {
    id?: string;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    createdBy?: UserDto | undefined;
    modifiedBy?: UserDto | undefined;
    listFolders?: ListFolderDto[] | undefined;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"] ? UserDto.fromJS(_data["modifiedBy"]) : <any>undefined;
            if (Array.isArray(_data["listFolders"])) {
                this.listFolders = [] as any;
                for (let item of _data["listFolders"])
                    this.listFolders!.push(ListFolderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : <any>undefined;
        if (Array.isArray(this.listFolders)) {
            data["listFolders"] = [];
            for (let item of this.listFolders)
                data["listFolders"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUserListDto {
    id?: string;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    createdBy?: UserDto | undefined;
    modifiedBy?: UserDto | undefined;
    listFolders?: ListFolderDto[] | undefined;
}

export class UserDto implements IUserDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    userRoles?: UserRole[] | undefined;
    contactNumber?: string | undefined;
    profilePic?: string | undefined;
    businessPhones?: string[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.userDomain = _data["userDomain"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.contactNumber = _data["contactNumber"];
            this.profilePic = _data["profilePic"];
            if (Array.isArray(_data["businessPhones"])) {
                this.businessPhones = [] as any;
                for (let item of _data["businessPhones"])
                    this.businessPhones!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["userDomain"] = this.userDomain;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item ? item.toJSON() : <any>undefined);
        }
        data["contactNumber"] = this.contactNumber;
        data["profilePic"] = this.profilePic;
        if (Array.isArray(this.businessPhones)) {
            data["businessPhones"] = [];
            for (let item of this.businessPhones)
                data["businessPhones"].push(item);
        }
        return data;
    }
}

export interface IUserDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
    userDomain?: RequestDomain | undefined;
    userRoles?: UserRole[] | undefined;
    contactNumber?: string | undefined;
    profilePic?: string | undefined;
    businessPhones?: string[] | undefined;
}

export enum RequestDomain {
    SDSG = 1,
    CXP = 2,
    CSS = 3,
    Crew = 4,
    Admin = 5,
}

export class UserRole implements IUserRole {
    roleName?: string | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserRole {
    roleName?: string | undefined;
}

export class ListFolderDto implements IListFolderDto {
    id?: string;
    name?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    savedListQueries?: ListQueryDto[] | undefined;

    constructor(data?: IListFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["savedListQueries"])) {
                this.savedListQueries = [] as any;
                for (let item of _data["savedListQueries"])
                    this.savedListQueries!.push(ListQueryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListFolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListFolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.savedListQueries)) {
            data["savedListQueries"] = [];
            for (let item of this.savedListQueries)
                data["savedListQueries"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IListFolderDto {
    id?: string;
    name?: string | undefined;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    savedListQueries?: ListQueryDto[] | undefined;
}

export class ListQueryDto implements IListQueryDto {
    id?: string;
    folderId?: string;
    starred?: boolean;
    queryName?: string | undefined;
    icon?: QueryIcon;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    queryFilters?: RequestListBuilderFilter | undefined;

    constructor(data?: IListQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.folderId = _data["folderId"];
            this.starred = _data["starred"];
            this.queryName = _data["queryName"];
            this.icon = _data["icon"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.queryFilters = _data["queryFilters"] ? RequestListBuilderFilter.fromJS(_data["queryFilters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["folderId"] = this.folderId;
        data["starred"] = this.starred;
        data["queryName"] = this.queryName;
        data["icon"] = this.icon;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["queryFilters"] = this.queryFilters ? this.queryFilters.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListQueryDto {
    id?: string;
    folderId?: string;
    starred?: boolean;
    queryName?: string | undefined;
    icon?: QueryIcon;
    createdOn?: Date;
    modifiedOn?: Date | undefined;
    queryFilters?: RequestListBuilderFilter | undefined;
}

export enum QueryIcon {
    PostIt = 0,
    Bug = 1,
    Settings = 2,
    Star = 3,
    Flag = 4,
    Warning = 5,
    Message = 6,
    Checkbox = 7,
    Notepad = 8,
    World = 9,
    Trophy = 10,
    Lightning = 11,
    Alarm = 12,
    Question = 13,
}

export class RequestListBuilderFilter implements IRequestListBuilderFilter {
    teamFilters?: TeamFilter | undefined;
    propertyFilters?: PropertyFilter[] | undefined;

    constructor(data?: IRequestListBuilderFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamFilters = _data["teamFilters"] ? TeamFilter.fromJS(_data["teamFilters"]) : <any>undefined;
            if (Array.isArray(_data["propertyFilters"])) {
                this.propertyFilters = [] as any;
                for (let item of _data["propertyFilters"])
                    this.propertyFilters!.push(PropertyFilter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestListBuilderFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RequestListBuilderFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamFilters"] = this.teamFilters ? this.teamFilters.toJSON() : <any>undefined;
        if (Array.isArray(this.propertyFilters)) {
            data["propertyFilters"] = [];
            for (let item of this.propertyFilters)
                data["propertyFilters"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IRequestListBuilderFilter {
    teamFilters?: TeamFilter | undefined;
    propertyFilters?: PropertyFilter[] | undefined;
}

export class TeamFilter implements ITeamFilter {
    requestTypes?: RequestType[] | undefined;

    constructor(data?: ITeamFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["requestTypes"])) {
                this.requestTypes = [] as any;
                for (let item of _data["requestTypes"])
                    this.requestTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): TeamFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TeamFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.requestTypes)) {
            data["requestTypes"] = [];
            for (let item of this.requestTypes)
                data["requestTypes"].push(item);
        }
        return data;
    }
}

export interface ITeamFilter {
    requestTypes?: RequestType[] | undefined;
}

export enum RequestType {
    Proposal = 1,
    Question = 2,
    Rfx = 3,
    PreSales = 4,
    PostSales = 5,
    CSSRequest = 6,
    CssReviewRequest = 7,
    CXP_VariantRequest = 8,
    CXP_PFR_Request = 9,
    CXP_MessagingRequest = 10,
    CXP_TechnicalRequest = 11,
    CXP_ProgramRequest = 12,
    CREW_WarrantyRequest = 13,
    CREW_ProductRequest = 14,
    CREW_MessagingRequest = 15,
}

export class PropertyFilter implements IPropertyFilter {
    condition?: Conditions;
    operator?: string | undefined;
    filter?: ListBuilderFilter | undefined;

    constructor(data?: IPropertyFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.condition = _data["condition"];
            this.operator = _data["operator"];
            this.filter = _data["filter"] ? ListBuilderFilter.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["condition"] = this.condition;
        data["operator"] = this.operator;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyFilter {
    condition?: Conditions;
    operator?: string | undefined;
    filter?: ListBuilderFilter | undefined;
}

export enum Conditions {
    Equals = 1,
    DoesNotEqual = 2,
    Contains = 3,
    DoesNotContain = 4,
    GreaterThan = 5,
    LessThan = 6,
    OlderThan = 7,
    YoungerThan = 8,
    Before = 9,
    After = 10,
    On = 11,
    State = 12,
}

export class ListBuilderFilter implements IListBuilderFilter {
    /** Status */
    status?: RequestStatus[] | undefined;
    /** Summary */
    title?: string | undefined;
    /** CreatedOn */
    createdOn?: Date | undefined;
    /** Assignee */
    assignedTo?: string[] | undefined;
    /** Tags */
    tags?: string[] | undefined;
    /** Description */
    description?: string | undefined;
    /** TotalRevenue */
    totalRevenueRisk?: number | undefined;
    /** TotalDeviceCount */
    totalDeviceRisk?: number | undefined;
    /** Aging */
    aging?: Aging[] | undefined;
    /** DeviceModels */
    troubledProductCategory?: string[] | undefined;
    /** RequestedResolutionDate */
    requestedResolutionDate?: Date | undefined;
    addedOn?: Date | undefined;
    /** OpportunityId */
    msxOpportunity?: string | undefined;
    /** MsxStatus */
    msxStatus?: string | undefined;
    /** TpId */
    tpid?: string | undefined;
    /** CustomerName */
    endCustomer?: string | undefined;
    /** MsxTotalDeviceCount */
    msxDeviceCount?: number | undefined;
    /** MsxTotalRevenue */
    msxTotalRevenue?: number | undefined;
    /** CustomerCountry */
    customerCountry?: string[] | undefined;
    /** CustomerImpacts */
    customerNumber?: number | undefined;
    /** Relationship */
    relationship?: AssociationType[] | undefined;
    childrenNumber?: number | undefined;
    internalComment?: string | undefined;
    externalComment?: string | undefined;
    externalStatusTimestamp?: string | undefined;
    externalStatus?: string | undefined;
    /** Attachments */
    attachment?: number | undefined;
    /** IsDesignForSurfacePossible */
    dfsPossible?: string | undefined;
    /** BugInformations */
    bugType?: BugInformation[] | undefined;
    /** BugNumber */
    bugNumber?: string | undefined;
    /** CssCaseNumber */
    cssCaseNumber?: string | undefined;
    /** IsDcfRequest */
    dcfRequest?: boolean | undefined;
    /** ProofOfPurchaseAttached */
    proofOfPurchaseAttached?: boolean | undefined;
    /** Priority */
    priority?: Priority[] | undefined;
    /** SerialNumbersAttached */
    serialNumberAttached?: boolean | undefined;
    /** DcfApprovedValue */
    dcfValue?: number | undefined;
    /** PriorityNumber */
    cxpPriorityNumber?: number | undefined;
    /** CreatedBy */
    submittedBy?: string[] | undefined;

    constructor(data?: IListBuilderFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            this.title = _data["title"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["assignedTo"])) {
                this.assignedTo = [] as any;
                for (let item of _data["assignedTo"])
                    this.assignedTo!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.description = _data["description"];
            this.totalRevenueRisk = _data["totalRevenueRisk"];
            this.totalDeviceRisk = _data["totalDeviceRisk"];
            if (Array.isArray(_data["aging"])) {
                this.aging = [] as any;
                for (let item of _data["aging"])
                    this.aging!.push(Aging.fromJS(item));
            }
            if (Array.isArray(_data["troubledProductCategory"])) {
                this.troubledProductCategory = [] as any;
                for (let item of _data["troubledProductCategory"])
                    this.troubledProductCategory!.push(item);
            }
            this.requestedResolutionDate = _data["requestedResolutionDate"] ? new Date(_data["requestedResolutionDate"].toString()) : <any>undefined;
            this.addedOn = _data["addedOn"] ? new Date(_data["addedOn"].toString()) : <any>undefined;
            this.msxOpportunity = _data["msxOpportunity"];
            this.msxStatus = _data["msxStatus"];
            this.tpid = _data["tpid"];
            this.endCustomer = _data["endCustomer"];
            this.msxDeviceCount = _data["msxDeviceCount"];
            this.msxTotalRevenue = _data["msxTotalRevenue"];
            if (Array.isArray(_data["customerCountry"])) {
                this.customerCountry = [] as any;
                for (let item of _data["customerCountry"])
                    this.customerCountry!.push(item);
            }
            this.customerNumber = _data["customerNumber"];
            if (Array.isArray(_data["relationship"])) {
                this.relationship = [] as any;
                for (let item of _data["relationship"])
                    this.relationship!.push(item);
            }
            this.childrenNumber = _data["childrenNumber"];
            this.internalComment = _data["internalComment"];
            this.externalComment = _data["externalComment"];
            this.externalStatusTimestamp = _data["externalStatusTimestamp"];
            this.externalStatus = _data["externalStatus"];
            this.attachment = _data["attachment"];
            this.dfsPossible = _data["dfsPossible"];
            if (Array.isArray(_data["bugType"])) {
                this.bugType = [] as any;
                for (let item of _data["bugType"])
                    this.bugType!.push(item);
            }
            this.bugNumber = _data["bugNumber"];
            this.cssCaseNumber = _data["cssCaseNumber"];
            this.dcfRequest = _data["dcfRequest"];
            this.proofOfPurchaseAttached = _data["proofOfPurchaseAttached"];
            if (Array.isArray(_data["priority"])) {
                this.priority = [] as any;
                for (let item of _data["priority"])
                    this.priority!.push(item);
            }
            this.serialNumberAttached = _data["serialNumberAttached"];
            this.dcfValue = _data["dcfValue"];
            this.cxpPriorityNumber = _data["cxpPriorityNumber"];
            if (Array.isArray(_data["submittedBy"])) {
                this.submittedBy = [] as any;
                for (let item of _data["submittedBy"])
                    this.submittedBy!.push(item);
            }
        }
    }

    static fromJS(data: any): ListBuilderFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ListBuilderFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        data["title"] = this.title;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        if (Array.isArray(this.assignedTo)) {
            data["assignedTo"] = [];
            for (let item of this.assignedTo)
                data["assignedTo"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["description"] = this.description;
        data["totalRevenueRisk"] = this.totalRevenueRisk;
        data["totalDeviceRisk"] = this.totalDeviceRisk;
        if (Array.isArray(this.aging)) {
            data["aging"] = [];
            for (let item of this.aging)
                data["aging"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.troubledProductCategory)) {
            data["troubledProductCategory"] = [];
            for (let item of this.troubledProductCategory)
                data["troubledProductCategory"].push(item);
        }
        data["requestedResolutionDate"] = this.requestedResolutionDate ? this.requestedResolutionDate.toISOString() : <any>undefined;
        data["addedOn"] = this.addedOn ? this.addedOn.toISOString() : <any>undefined;
        data["msxOpportunity"] = this.msxOpportunity;
        data["msxStatus"] = this.msxStatus;
        data["tpid"] = this.tpid;
        data["endCustomer"] = this.endCustomer;
        data["msxDeviceCount"] = this.msxDeviceCount;
        data["msxTotalRevenue"] = this.msxTotalRevenue;
        if (Array.isArray(this.customerCountry)) {
            data["customerCountry"] = [];
            for (let item of this.customerCountry)
                data["customerCountry"].push(item);
        }
        data["customerNumber"] = this.customerNumber;
        if (Array.isArray(this.relationship)) {
            data["relationship"] = [];
            for (let item of this.relationship)
                data["relationship"].push(item);
        }
        data["childrenNumber"] = this.childrenNumber;
        data["internalComment"] = this.internalComment;
        data["externalComment"] = this.externalComment;
        data["externalStatusTimestamp"] = this.externalStatusTimestamp;
        data["externalStatus"] = this.externalStatus;
        data["attachment"] = this.attachment;
        data["dfsPossible"] = this.dfsPossible;
        if (Array.isArray(this.bugType)) {
            data["bugType"] = [];
            for (let item of this.bugType)
                data["bugType"].push(item);
        }
        data["bugNumber"] = this.bugNumber;
        data["cssCaseNumber"] = this.cssCaseNumber;
        data["dcfRequest"] = this.dcfRequest;
        data["proofOfPurchaseAttached"] = this.proofOfPurchaseAttached;
        if (Array.isArray(this.priority)) {
            data["priority"] = [];
            for (let item of this.priority)
                data["priority"].push(item);
        }
        data["serialNumberAttached"] = this.serialNumberAttached;
        data["dcfValue"] = this.dcfValue;
        data["cxpPriorityNumber"] = this.cxpPriorityNumber;
        if (Array.isArray(this.submittedBy)) {
            data["submittedBy"] = [];
            for (let item of this.submittedBy)
                data["submittedBy"].push(item);
        }
        return data;
    }
}

export interface IListBuilderFilter {
    /** Status */
    status?: RequestStatus[] | undefined;
    /** Summary */
    title?: string | undefined;
    /** CreatedOn */
    createdOn?: Date | undefined;
    /** Assignee */
    assignedTo?: string[] | undefined;
    /** Tags */
    tags?: string[] | undefined;
    /** Description */
    description?: string | undefined;
    /** TotalRevenue */
    totalRevenueRisk?: number | undefined;
    /** TotalDeviceCount */
    totalDeviceRisk?: number | undefined;
    /** Aging */
    aging?: Aging[] | undefined;
    /** DeviceModels */
    troubledProductCategory?: string[] | undefined;
    /** RequestedResolutionDate */
    requestedResolutionDate?: Date | undefined;
    addedOn?: Date | undefined;
    /** OpportunityId */
    msxOpportunity?: string | undefined;
    /** MsxStatus */
    msxStatus?: string | undefined;
    /** TpId */
    tpid?: string | undefined;
    /** CustomerName */
    endCustomer?: string | undefined;
    /** MsxTotalDeviceCount */
    msxDeviceCount?: number | undefined;
    /** MsxTotalRevenue */
    msxTotalRevenue?: number | undefined;
    /** CustomerCountry */
    customerCountry?: string[] | undefined;
    /** CustomerImpacts */
    customerNumber?: number | undefined;
    /** Relationship */
    relationship?: AssociationType[] | undefined;
    childrenNumber?: number | undefined;
    internalComment?: string | undefined;
    externalComment?: string | undefined;
    externalStatusTimestamp?: string | undefined;
    externalStatus?: string | undefined;
    /** Attachments */
    attachment?: number | undefined;
    /** IsDesignForSurfacePossible */
    dfsPossible?: string | undefined;
    /** BugInformations */
    bugType?: BugInformation[] | undefined;
    /** BugNumber */
    bugNumber?: string | undefined;
    /** CssCaseNumber */
    cssCaseNumber?: string | undefined;
    /** IsDcfRequest */
    dcfRequest?: boolean | undefined;
    /** ProofOfPurchaseAttached */
    proofOfPurchaseAttached?: boolean | undefined;
    /** Priority */
    priority?: Priority[] | undefined;
    /** SerialNumbersAttached */
    serialNumberAttached?: boolean | undefined;
    /** DcfApprovedValue */
    dcfValue?: number | undefined;
    /** PriorityNumber */
    cxpPriorityNumber?: number | undefined;
    /** CreatedBy */
    submittedBy?: string[] | undefined;
}

export enum RequestStatus {
    New = 1,
    Active = 2,
    InProgress = 3,
    Resolved = 4,
    Closed = 5,
}

export class Aging implements IAging {
    start?: Date;
    end?: Date;
    range?: string | undefined;

    constructor(data?: IAging) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.range = _data["range"];
        }
    }

    static fromJS(data: any): Aging {
        data = typeof data === 'object' ? data : {};
        let result = new Aging();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["range"] = this.range;
        return data;
    }
}

export interface IAging {
    start?: Date;
    end?: Date;
    range?: string | undefined;
}

export enum AssociationType {
    Parent = 1,
    Child = 2,
    None = 3,
}

export enum BugInformation {
    PLE_Bug = 1,
    MSFT_Devices_Non_PLE_Bug = 2,
    OS_Bug = 3,
    Hub_OS_Bug = 4,
    Other_Bugs = 5,
    Azure_Devops_Link = 6,
}

export enum Priority {
    High = 1,
    Medium = 2,
    Low = 3,
}

/** Represents a void type, since Void is not a valid return type in C#. */
export class Unit implements IUnit {

    constructor(data?: IUnit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Represents a void type, since Void is not a valid return type in C#. */
export interface IUnit {
}

export class UpdateFolderPropertyDto implements IUpdateFolderPropertyDto {
    name?: string | undefined;
    folderId?: string;

    constructor(data?: IUpdateFolderPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.folderId = _data["folderId"];
        }
    }

    static fromJS(data: any): UpdateFolderPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFolderPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["folderId"] = this.folderId;
        return data;
    }
}

export interface IUpdateFolderPropertyDto {
    name?: string | undefined;
    folderId?: string;
}

export class PaginatedListOfNotificationDto implements IPaginatedListOfNotificationDto {
    items?: NotificationDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NotificationDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfNotificationDto {
    items?: NotificationDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class NotificationDto implements INotificationDto {
    userId?: string;
    entityType?: EntityType;
    entityId?: string | undefined;
    parentEntityType?: EntityType;
    parentEntityId?: string | undefined;
    isRead?: boolean;
    text?: string | undefined;
    eventType?: number;
    createdOn?: Date;
    updatedOn?: Date;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.parentEntityType = _data["parentEntityType"];
            this.parentEntityId = _data["parentEntityId"];
            this.isRead = _data["isRead"];
            this.text = _data["text"];
            this.eventType = _data["eventType"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["parentEntityType"] = this.parentEntityType;
        data["parentEntityId"] = this.parentEntityId;
        data["isRead"] = this.isRead;
        data["text"] = this.text;
        data["eventType"] = this.eventType;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface INotificationDto {
    userId?: string;
    entityType?: EntityType;
    entityId?: string | undefined;
    parentEntityType?: EntityType;
    parentEntityId?: string | undefined;
    isRead?: boolean;
    text?: string | undefined;
    eventType?: number;
    createdOn?: Date;
    updatedOn?: Date;
}

export enum EntityType {
    HelpRequest = 1,
    Feedback = 2,
    Article = 3,
    Comment = 4,
    Report = 5,
    Status = 6,
}

export class CreateNotificationUnsubscribeFeedbackDto implements ICreateNotificationUnsubscribeFeedbackDto {
    entityType?: EntityType;
    parentEntityType?: EntityType | undefined;
    reason?: string | undefined;
    eventType?: number;
    shouldResubscribe?: boolean;

    constructor(data?: ICreateNotificationUnsubscribeFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.parentEntityType = _data["parentEntityType"];
            this.reason = _data["reason"];
            this.eventType = _data["eventType"];
            this.shouldResubscribe = _data["shouldResubscribe"];
        }
    }

    static fromJS(data: any): CreateNotificationUnsubscribeFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNotificationUnsubscribeFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["parentEntityType"] = this.parentEntityType;
        data["reason"] = this.reason;
        data["eventType"] = this.eventType;
        data["shouldResubscribe"] = this.shouldResubscribe;
        return data;
    }
}

export interface ICreateNotificationUnsubscribeFeedbackDto {
    entityType?: EntityType;
    parentEntityType?: EntityType | undefined;
    reason?: string | undefined;
    eventType?: number;
    shouldResubscribe?: boolean;
}

export class UserPreferencesDto implements IUserPreferencesDto {
    dashboardColumn?: string[] | undefined;
    dashboardView?: string | undefined;
    dashboardDateFilter?: string | undefined;
    newsletterSubscription?: boolean;
    knowledgeCenterSubscription?: boolean;
    requestType?: string | undefined;
    assignee?: string | undefined;
    caseStatus?: string | undefined;
    deviceModel?: string | undefined;
    relationship?: string | undefined;
    aging?: string | undefined;
    dcfRequest?: string | undefined;
    requestHelpExperience?: RequestHelpExperience | undefined;

    constructor(data?: IUserPreferencesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dashboardColumn"])) {
                this.dashboardColumn = [] as any;
                for (let item of _data["dashboardColumn"])
                    this.dashboardColumn!.push(item);
            }
            this.dashboardView = _data["dashboardView"];
            this.dashboardDateFilter = _data["dashboardDateFilter"];
            this.newsletterSubscription = _data["newsletterSubscription"];
            this.knowledgeCenterSubscription = _data["knowledgeCenterSubscription"];
            this.requestType = _data["requestType"];
            this.assignee = _data["assignee"];
            this.caseStatus = _data["caseStatus"];
            this.deviceModel = _data["deviceModel"];
            this.relationship = _data["relationship"];
            this.aging = _data["aging"];
            this.dcfRequest = _data["dcfRequest"];
            this.requestHelpExperience = _data["requestHelpExperience"];
        }
    }

    static fromJS(data: any): UserPreferencesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreferencesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dashboardColumn)) {
            data["dashboardColumn"] = [];
            for (let item of this.dashboardColumn)
                data["dashboardColumn"].push(item);
        }
        data["dashboardView"] = this.dashboardView;
        data["dashboardDateFilter"] = this.dashboardDateFilter;
        data["newsletterSubscription"] = this.newsletterSubscription;
        data["knowledgeCenterSubscription"] = this.knowledgeCenterSubscription;
        data["requestType"] = this.requestType;
        data["assignee"] = this.assignee;
        data["caseStatus"] = this.caseStatus;
        data["deviceModel"] = this.deviceModel;
        data["relationship"] = this.relationship;
        data["aging"] = this.aging;
        data["dcfRequest"] = this.dcfRequest;
        data["requestHelpExperience"] = this.requestHelpExperience;
        return data;
    }
}

export interface IUserPreferencesDto {
    dashboardColumn?: string[] | undefined;
    dashboardView?: string | undefined;
    dashboardDateFilter?: string | undefined;
    newsletterSubscription?: boolean;
    knowledgeCenterSubscription?: boolean;
    requestType?: string | undefined;
    assignee?: string | undefined;
    caseStatus?: string | undefined;
    deviceModel?: string | undefined;
    relationship?: string | undefined;
    aging?: string | undefined;
    dcfRequest?: string | undefined;
    requestHelpExperience?: RequestHelpExperience | undefined;
}

export enum RequestHelpExperience {
    New = "new",
    Legacy = "legacy",
}

export class GetReportDto implements IGetReportDto {
    id?: string;
    displayName?: string | undefined;
    url?: string | undefined;
    type?: ReportType;
    modifiedOn?: Date | undefined;
    isBookmarked?: boolean;
    sharedWithTeams?: string | undefined;
    sharedWithUsers?: ReportUserDto[] | undefined;

    constructor(data?: IGetReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.url = _data["url"];
            this.type = _data["type"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.isBookmarked = _data["isBookmarked"];
            this.sharedWithTeams = _data["sharedWithTeams"];
            if (Array.isArray(_data["sharedWithUsers"])) {
                this.sharedWithUsers = [] as any;
                for (let item of _data["sharedWithUsers"])
                    this.sharedWithUsers!.push(ReportUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["url"] = this.url;
        data["type"] = this.type;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["isBookmarked"] = this.isBookmarked;
        data["sharedWithTeams"] = this.sharedWithTeams;
        if (Array.isArray(this.sharedWithUsers)) {
            data["sharedWithUsers"] = [];
            for (let item of this.sharedWithUsers)
                data["sharedWithUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGetReportDto {
    id?: string;
    displayName?: string | undefined;
    url?: string | undefined;
    type?: ReportType;
    modifiedOn?: Date | undefined;
    isBookmarked?: boolean;
    sharedWithTeams?: string | undefined;
    sharedWithUsers?: ReportUserDto[] | undefined;
}

export enum ReportType {
    ApplicationReport = 1,
    UtilizationInsightsReport = 2,
}

export class ReportUserDto implements IReportUserDto {
    id?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    isBookmarked?: boolean;
    userDomain?: RequestDomain | undefined;

    constructor(data?: IReportUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.isBookmarked = _data["isBookmarked"];
            this.userDomain = _data["userDomain"];
        }
    }

    static fromJS(data: any): ReportUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["isBookmarked"] = this.isBookmarked;
        data["userDomain"] = this.userDomain;
        return data;
    }
}

export interface IReportUserDto {
    id?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    isBookmarked?: boolean;
    userDomain?: RequestDomain | undefined;
}

export class CreateReportDto implements ICreateReportDto {
    displayName?: string | undefined;
    url?: string | undefined;
    type?: ReportType;
    sharedWithTeams?: string | undefined;
    sharedWithUsers?: ReportUserDto[] | undefined;

    constructor(data?: ICreateReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.url = _data["url"];
            this.type = _data["type"];
            this.sharedWithTeams = _data["sharedWithTeams"];
            if (Array.isArray(_data["sharedWithUsers"])) {
                this.sharedWithUsers = [] as any;
                for (let item of _data["sharedWithUsers"])
                    this.sharedWithUsers!.push(ReportUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["url"] = this.url;
        data["type"] = this.type;
        data["sharedWithTeams"] = this.sharedWithTeams;
        if (Array.isArray(this.sharedWithUsers)) {
            data["sharedWithUsers"] = [];
            for (let item of this.sharedWithUsers)
                data["sharedWithUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICreateReportDto {
    displayName?: string | undefined;
    url?: string | undefined;
    type?: ReportType;
    sharedWithTeams?: string | undefined;
    sharedWithUsers?: ReportUserDto[] | undefined;
}

export class UpdateReportDto extends CreateReportDto implements IUpdateReportDto {
    id?: string;

    constructor(data?: IUpdateReportDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): UpdateReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateReportDto extends ICreateReportDto {
    id?: string;
}

export class UpdateReportSharedWithDto implements IUpdateReportSharedWithDto {
    id?: string;
    sharedWithTeams?: string | undefined;
    sharedWithUsers?: ReportUserDto[] | undefined;

    constructor(data?: IUpdateReportSharedWithDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sharedWithTeams = _data["sharedWithTeams"];
            if (Array.isArray(_data["sharedWithUsers"])) {
                this.sharedWithUsers = [] as any;
                for (let item of _data["sharedWithUsers"])
                    this.sharedWithUsers!.push(ReportUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateReportSharedWithDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReportSharedWithDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sharedWithTeams"] = this.sharedWithTeams;
        if (Array.isArray(this.sharedWithUsers)) {
            data["sharedWithUsers"] = [];
            for (let item of this.sharedWithUsers)
                data["sharedWithUsers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateReportSharedWithDto {
    id?: string;
    sharedWithTeams?: string | undefined;
    sharedWithUsers?: ReportUserDto[] | undefined;
}

export class PaginatedListOfGetReportDto implements IPaginatedListOfGetReportDto {
    items?: GetReportDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfGetReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetReportDto.fromJS(item));
            }
            this.pageIndex = _data["pageIndex"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.pageSize = _data["pageSize"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfGetReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfGetReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["pageIndex"] = this.pageIndex;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["pageSize"] = this.pageSize;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfGetReportDto {
    items?: GetReportDto[] | undefined;
    pageIndex?: number;
    totalPages?: number;
    totalCount?: number;
    pageSize?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export enum ListSortDirection {
    Ascending = 0,
    Descending = 1,
}

export class SubmitterDto implements ISubmitterDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;

    constructor(data?: ISubmitterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SubmitterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        return data;
    }
}

export interface ISubmitterDto {
    id?: string;
    displayName?: string | undefined;
    email?: string | undefined;
}

export class GraphUserDto implements IGraphUserDto {
    id?: string;
    displayName?: string | undefined;
    mail?: string | undefined;
    userDomain?: RequestDomain | undefined;

    constructor(data?: IGraphUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.mail = _data["mail"];
            this.userDomain = _data["userDomain"];
        }
    }

    static fromJS(data: any): GraphUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new GraphUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["mail"] = this.mail;
        data["userDomain"] = this.userDomain;
        return data;
    }
}

export interface IGraphUserDto {
    id?: string;
    displayName?: string | undefined;
    mail?: string | undefined;
    userDomain?: RequestDomain | undefined;
}

export class GraphUser implements IGraphUser {
    id?: string | undefined;
    displayName?: string | undefined;
    mail?: string | undefined;

    constructor(data?: IGraphUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.mail = _data["mail"];
        }
    }

    static fromJS(data: any): GraphUser {
        data = typeof data === 'object' ? data : {};
        let result = new GraphUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["mail"] = this.mail;
        return data;
    }
}

export interface IGraphUser {
    id?: string | undefined;
    displayName?: string | undefined;
    mail?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class UserApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isUserApiException = true;

    static isUserApiException(obj: any): obj is UserApiException {
        return obj.isUserApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new UserApiException(message, status, response, headers, null);
}

// Adds Authorization header to requests made by the nswag generated clients. Also handles 401 responses by redirecting to login page for a new token.

export class ApiError extends Error {
    status: number;
    statusText: string;
    detail: any;

    constructor(status: number, statusText: string, detail?: any) {
        super(`${status} ${statusText}`);
        this.name = 'ApiError';
        this.status = status;
        this.statusText = statusText;
        this.detail = detail;
    }

    static isApiError(obj: any): obj is ApiError {
        return obj instanceof ApiError;
    }
}